import "../ESign/ESignForm/ESignForm.scss";
import * as React from "react";
import DocStatus from "../ESign/DocStatus/DocStatus";
import Button, { TransparentButton, Verify } from "../UI/Button/Button";
import blueTick from "../../assets/icons/blueTick.svg";
import GlobalStore from "../store/globalStore";
import {
  APendingUploadList,
  APendingApprovalList,
  AGetEsignUrlDetails,
} from "../Services/dashboard/eSignApiServices";
import ErrMsg from "../UI/ErrMsg/ErrMsg";
import {
  AGetUploadedDocument,
  QCServiceTaskCreation,
} from "../Services/dashboard/docVerificationAPIServices";
import { downloadForm } from "../POA/Poa";
import useQuery from "../../customHooks/useQuery";
import { setStageData } from "../Services/globalService";
import Radio from "../UI/Radio/Radio";
import {
  AGetOtpNew,
  ALeadFetchApi,
  AValidateOtpNew,
} from "../Services/registration/registrationApiService";
import {
  AGetStageCompletionStatus,
  AUpdateStageCompletionStatus,
} from "../Services/registration/continueApiService";
import { ILeadFormFields } from "../Registration/RegistrationForm/RegistrationForm";
import InputField from "../UI/InputField/InputField";
import {
  emailRegex,
  forbiddenWordsRegex,
  integerExp,
  phoneNo,
} from "../utils/regex";
import { errorCode, errorMsg } from "../../ErrorCode/ErrorCode";
import RegOtp from "../Registration/RegOtp/RegOtp";
import { containerUrl } from "../utils/constants";
import { useHistory } from "react-router-dom";
import { decryptJwtToken } from "../Services/dashboard/encryptionNew";
import { ITokenObj } from "../types/genericTypes";
let intervalTimer: any;
export interface ILeadDetails {
  email?: string;
  mobile?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  pan?: string;
  dob?: string;
  productid?: string;
  categoryid?: string;
  rmid?: string;
  leadid?: string;
  accountCategory?: string;
  isMobileVerified?: boolean;
  isEmailVerified?: boolean;
  isPanVerified?: boolean;
  uccCode?: string;
}
const KRAAuthenticateForm = (props: any) => {
  const quryParams = useQuery();
  const history = useHistory();
  const [values, setValues] = React.useState({
    email: "",
    mobile: "",
  });
  const UTM_SOURCE = quryParams.get("utm_source")
    ? quryParams.get("utm_source")
    : "";
  const UTM_MEDIUM = quryParams.get("utm_medium")
    ? quryParams.get("utm_medium")
    : "";
  const UTM_CAMPAIGN = quryParams.get("utm_campaign")
    ? quryParams.get("utm_campaign")
    : "";
  const [radioSelection, setRadioSelection] = React.useState<boolean>(true);
  const [isVerified, setIsVerified] = React.useState<{
    type: string;
    isVerify: boolean;
  }>({
    type: "MOB",
    isVerify: false,
  });
  const [rmAssited, setRmAssited] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<{
    [key in keyof ILeadFormFields]?: string;
  }>({
    email: undefined,
    mobile: undefined,
  });
  const [errCode, setErrCode] = React.useState<number | string>();
  const [otpIds, setOtpIds] = React.useState<{
    emailOtpId?: string;
    mobileOtpId?: string;
  }>({
    emailOtpId: undefined,
    mobileOtpId: undefined,
  });
  const [showMobileBtn, setShowMobileBtn] = React.useState<boolean>(true);
  const [showMobileMailBtn, setShowMobileMailBtn] =
    React.useState<boolean>(true);
  const [showMobileOtp, setShowMobileOtp] = React.useState<boolean>(false);
  const [disableOtp, setDisableOtp] = React.useState<boolean>(false);
  const [isMobileVerified, setIsMobileVerified] =
    React.useState<boolean>(false);
  const [isEmailVerified, setIsEmailVerified] = React.useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [invalidOtp, setInvalidOtp] = React.useState<boolean>(false);
  const [showEmailOtp, setShowEmailOtp] = React.useState<boolean>(false);
  const [disableEmailOtp, setDisableEmailOtp] = React.useState<boolean>(false);
  const [invalidEmailOtp, setInvalidEmailOtp] = React.useState<boolean>(false);
  const [mailVerifiedFE, setMailVerifiedFE] = React.useState<boolean>(false);
  const [leadDetails, setLeadDetails] = React.useState<ILeadDetails>({});
  const [mobileVerifiedFE, setMobileVerifiedFE] =
    React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showResult, setShowResult] = React.useState<boolean>(false);
  const [proceedToAutheticate, setProceedToAutheticate] =
    React.useState<boolean>(false);
  const [isPendingUpload, setIsPendingUpload] = React.useState<boolean>(true);
  const [isPendingApproval, setIsPendingApproval] =
    React.useState<boolean>(true);
  const [pendingUploadList, setPendingUploadList] = React.useState<Array<any>>(
    []
  );
  const [pendingApprovalList, setPendingApprovalList] = React.useState<
    Array<any>
  >([]);
  React.useEffect(() => {
    AGetStageCompletionStatus((res: any) => {
      getClientStageDetails(res);
    }, GlobalStore.applicationID);
    if (GlobalStore.stageStatus.bpm_pd_status === 1) {
      setIsPendingUpload(false);
      setIsPendingApproval(false);
      setShowResult(true);
      setIsLoading(false);
    } else {
      APendingUploadList(checkPendingUpload, GlobalStore.applicationID);
    }
    GetLeadDetails(GlobalStore?.leadId);
    return () => {
      clearInterval(intervalTimer);
    };
  }, []);
  function getClientStageDetails(res: any) {
    setIsLoading(false);
    if (!res || res.error) {
      // setErrCode('1061 - Error in fetching stage completion details.');
      // setErrCode(errorMessage.getClientStageDetails);
      // gtmService({
      //   action: "GetStageCompletionStatus",
      //   label: "ERROR || ERR147",
      // });
      setErrCode(res.error);
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        if (responseObj !== null && responseObj != undefined) {
          if (
            responseObj?.rmassisted !== null &&
            responseObj?.rmassisted !== undefined &&
            responseObj?.rmassisted
          ) {
            setRmAssited(true);
          }
        }
        setValues((values) => {
          if (responseObj.emailid !== undefined) {
            values.email = responseObj.emailid;
          }
          if (responseObj.mobileno !== undefined)
            values.mobile = responseObj.mobileno;
          return values;
        });
      } else {
        // gtmService({
        //   action: "GetStageCompletionStatus",
        //   label: "ERROR || ERR147-S",
        // });
      }
    }
  }
  function validateOtp(otpType: "email" | "mobile", val: string) {
    if (invalidOtp) {
      setInvalidOtp(false);
    }
    if (invalidEmailOtp) {
      setInvalidEmailOtp(false);
    }
    if (val.length === 4) {
      setIsLoading(true);
      if (otpType === "email") {
        setDisableEmailOtp(true);
      } else if (otpType === "mobile") {
        setDisableOtp(true);
      }
      AValidateOtpNew(
        (res: any) => {
          if (otpType === "email") {
            checkEmailValidateOtpNew(res);
          } else {
            checkMobileValidateOtpNew(res);
          }
        },
        otpType == "email" ? otpIds?.emailOtpId : otpIds?.mobileOtpId,
        val
      );
    }
  }
  function checkEmailValidateOtpNew(res: any) {
    setDisableEmailOtp(false);
    if (!res || res.error) {
      //setErrCode('102 - Failed to fetch existing Leads');
      // setErrCode(errorMessage.searchLead);
      setErrCode(res.error);
    } else {
      console.log(res, "works");
      if (
        res.data &&
        res?.data?.data &&
        !!res?.data?.success &&
        res?.data?.success == true
      ) {
        GlobalStore.user.email = values.email;
        setIsEmailVerified(true);
        setIsVerified((isVerified) => {
          isVerified.type = "EMAIL";
          isVerified.isVerify = true;
          return isVerified;
        });
        setShowEmailOtp(false);
        setMailVerifiedFE(true);
      } else {
        setIsVerified((isVerified) => {
          isVerified.type = "EMAIL";
          isVerified.isVerify = false;
          return isVerified;
        });
        setInvalidEmailOtp(true);
      }

      setErrCode("");
    }
    setIsLoading(false);
  }
  function checkMobileValidateOtpNew(res: any) {
    setIsLoading(false);
    setDisableOtp(false);
    if (res.error) {
      //setErrCode('115 - Failed to validate OTP, please retry.');
      setErrCode(res.error);
    } else {
      if (
        res.data &&
        res?.data?.data &&
        !!res?.data?.success &&
        res?.data?.success == true
      ) {
        GlobalStore.user.mobile = values.mobile;
        setIsMobileVerified(true);
        setIsVerified((isVerified) => {
          isVerified.type = "MOB";
          isVerified.isVerify = true;
          return isVerified;
        });
        setShowMobileOtp(false);
        setMobileVerifiedFE(true);
      } else {
        setIsVerified((isVerified) => {
          isVerified.type = "MOB";
          isVerified.isVerify = false;
          return isVerified;
        });
        setInvalidOtp(true);
      }
      setErrCode("");
    }
  }
  function sendOtp() {
    setIsLoading(true);
    //AGetMobileOtp(otpSent, values.mobile);
    AGetOtpNew(
      (res: any) => {
        console.log("MON", res);
        mobileOtpSentNew(res);
      },
      values.mobile,
      "SMS"
    );
  }
  function mobileOtpSentNew(res: any) {
    // console.log(res);

    if (
      res?.data?.data !== null &&
      res?.data?.data !== undefined &&
      !!res?.data?.data?.OTPId &&
      res?.data?.data?.OTPId !== ""
    ) {
      setOtpIds((otpIds) => {
        otpIds.mobileOtpId = res?.data?.data?.OTPId;
        return otpIds;
      });
      setIsLoading(false);
      setShowMobileBtn(false);
      setShowMobileOtp(true);
      setErrCode("");
    } else {
      if (res?.error) {
        setErrCode(res.error);
      } else {
        setErrCode("Failed to send OTP, please retry.");
      }
      setIsLoading(false);
      setShowMobileOtp(false);
    }
    //  else {
    //   //setErrCode('114 - Failed to send OTP, please retry.');
    //   setErrCode(res.error);
    // }
  }
  function sendEmailOtp() {
    setIsLoading(true);
    //   AGetEmailOtp((res: any) => emailOtpRes(res), emlObj);
    AGetOtpNew(
      (res: any) => {
        emailOtpResNew(res);
      },
      values.email,
      "EMAIL"
    );
  }
  function emailOtpResNew(res: any) {
    if (res.data && res.status) {
      if (
        res?.data?.data !== null &&
        res?.data?.data !== undefined &&
        !!res?.data?.data?.OTPId &&
        res?.data?.data?.OTPId !== ""
      ) {
        setOtpIds((otpIds) => {
          otpIds.emailOtpId = res?.data?.data?.OTPId;
          return otpIds;
        });
        setShowEmailOtp(true);
        setShowMobileMailBtn(false);
        setErrCode("");
      } else {
        setErrCode("Failed to send OTP, please retry.");
      }
    } else {
      // setErrCode('114 - Failed to send OTP, please retry.');
      setErrCode(res.error);
    }
    setIsLoading(false);
  }
  function checkPendingUpload(res: any) {
    if (!res || res.error) {
      //   setErrCode("");
      setErrCode(res.error);
      // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR115" });
      setIsLoading(false);
    } else {
      if (res && res.data) {
        // let list: Array<any> = JSON.parse(JSON.parse(res.data)).filter((item: any) => item.documentcategoryid !== 36 && item.documentcategoryid !== 30 && item.documentcategoryid !== 62);
        let list: Array<any> = JSON.parse(res.data).filter(
          (item: any) =>
            // Prev api response
            // item.mandatory

            // Cureent Response
            item.Mandatory
        );
        if (list.length === 0) {
          setIsLoading(true);
          setIsPendingUpload(false);
          if (GlobalStore.stageStatus.bpm_pd_status === 0)
            AGetUploadedDocument(getUploadedDocList, GlobalStore.applicationID);
          if (GlobalStore.stageStatus.bpm_pd_status === 1) {
            setIsPendingUpload(false);
            setShowResult(true);
            setIsPendingApproval(false);
            setIsLoading(false);
          }
          if (
            GlobalStore.stageStatus.bpm_pd_status === 2 ||
            GlobalStore.stageStatus.bpm_pd_status === 3
          )
            APendingApprovalList(
              checkPendingApproval,
              GlobalStore.applicationID
            );
        } else {
          // const arr: Array<{
          //   contenttype: string;
          //   status: string;
          //   documenttype: string;
          // }> = [];
          // for (let i = 0; i < list.length; i++) {
          //   let obj: {
          //     contenttype: string;
          //     status: string;
          //     documenttype: string;
          //   } = {
          //     contenttype: list[i].DocumentCategory,
          //     status: "Pending Approval",
          //     documenttype: list[i].DocumentName,
          //   };
          //   arr.push(obj);
          // }
          // setPendingApprovalList(arr);
          setPendingUploadList(list);
          setIsLoading(false);
          setShowResult(true);
        }
      }
    }
  }
  const GetLeadDetails = (leadId?: string) => {
    if (leadId !== null && leadId !== undefined && leadId !== "") {
      ALeadFetchApi(
        (res: any) => {
          if (!res || res.error) {
            // setErrCode(164)
            setErrCode(errCode + res.error);
            // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
          } else if (res?.data) {
            if (Array?.isArray(res?.data) && res?.data?.length > 0) {
              const leadObj = res?.data[0] as ILeadDetails;
              GlobalStore.personaldetails.pan = leadObj.pan
              if (leadObj !== undefined) {
                // setValues((values) => {
                //   if (leadObj?.email !== undefined) {
                //     values.email = leadObj?.email;
                //   }
                //   if (leadObj?.mobile !== undefined)
                //     values.mobile = leadObj?.mobile;
                //   return values;
                // });
              }

              setLeadDetails(leadObj);
            }
          }
        },
        {
          id: leadId,
          name: "",
          stageFlag: 2,
        }
      );
    }
  };
  const updateStageStatus = () => {
    setIsLoading(true);
    let userId = "0";
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = tokenMainObj?.UserId?.toString();
    }
    let reaObj = {
      applicationId: GlobalStore?.applicationID,
      accountCagtegory: GlobalStore?.stageStatus?.accountcategory,
      stageOrderId: 11,
      UserId: userId,
      rmassisted: rmAssited,
    };
    AUpdateStageCompletionStatus((req: any) => {
      if (!req || req.error) {
        // setErrCode("118 - Error in fetching Client details from our system.");
        setErrCode(req.error);
        // gtmService({
        //   action: "GetClientDataByPanOrLead",
        //   label: "ERROR || ERR148",
        // });
        setIsLoading(false);
      } else {
        if (req?.data !== null) {
          if (GlobalStore?.isKRA) {
            createTask();
            // history.replace(containerUrl.esignsubmit);
          }
        }
      }
    }, reaObj);
  };
  function checkPendingApproval(res: any) {
    setIsLoading(false);
    if (!res || res.error) {
      setErrCode("");
      // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR116" });
    } else {
      if (res && res.data) {
        let list: Array<any> = JSON.parse(res.data).filter(
          (item: any) => item.DocumentType
        );
        let showList: boolean = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].Status !== "Approved") {
            showList = true;
            break;
          }
        }
        if (showList) setPendingApprovalList(list);
        else setIsPendingApproval(false);
        setShowResult(true);
      }
    }
  }
  const createTask = () => {
    QCServiceTaskCreation(
      (res: any) => {
        if (!res || res.error) {
          setIsLoading(false);
          // gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });
          // setIsLoading(false);
          // handErrorForFileUpload(id, res);
          setErrCode(res.error);
          setIsLoading(false);
          // setLoaderSign(false);
        } else {
          if (res && res.data !== null && Object.keys(res?.data)?.length > 0) {
            // getSaveStatusNew();
            history.replace(containerUrl.submit);
          } else {
            setErrCode("Something went wrong. please try again later.");
            setIsLoading(false);
            // setLoaderSign(false);
          }
        }
      },
      GlobalStore?.applicationID,
      GlobalStore.stageStatus.accountcategory
        ? GlobalStore?.stageStatus?.accountcategory
        : 0
    );
  };
  function getUploadedDocList(res: any) {
    if (!res || res.error) {
      setErrCode("");
      //    gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR118" });
    } else {
      const responseObj = JSON.parse(res.data);
      if (responseObj) {
        const list: Array<any> = responseObj.filter(
          (item: any) => item.DocumentName
        );
        const arr: Array<{
          contenttype: string;
          status: string;
          documenttype: string;
        }> = [];
        for (let i = 0; i < list.length; i++) {
          let obj: {
            contenttype: string;
            status: string;
            documenttype: string;
          } = {
            contenttype: list[i].DocumentCategory,
            status: list[i].WsdlFlag,
            documenttype: list[i].DocumentName,
          };
          arr.push(obj);
        }
        setPendingApprovalList(arr);
        setShowResult(true);
        // checkPdStatus();
      } else {
        setErrCode("");
      }
    }
    setIsLoading(false);
  }
  const checkDisabledForm = () => {
    let disabledButton = false;
    if (isVerified?.type !== null && isVerified?.isVerify == true) {
      disabledButton = false;
    } else disabledButton = true;
    return disabledButton;
  };
  const generateEsignFields = (showMobile: boolean) => {
    return (
      <>
        {showMobile == false && (
          <>
            <div className="email">
              <div className="row emlInput">
                <label className="inptLbl">Email ID</label>
                <InputField
                  pattern={emailRegex}
                  defaultValue={values?.email}
                  disabled={true}
                  onChange={(value) => {
                    if (forbiddenWordsRegex.test(value)) {
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: errorMsg(errorCode.FE48),
                      });
                    } else {
                      setShowMobileMailBtn(true);
                      setIsEmailVerified(false);
                      setIsButtonDisabled(false);

                      //   onChange("email", value);
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: "",
                      });
                      // onChange("email", value);
                    }
                  }}
                  onBlur={(error, e) => {
                    if (
                      e?.target?.value !== undefined &&
                      e?.target?.value !== null &&
                      e?.target?.value !== "" &&
                      forbiddenWordsRegex.test(e?.target?.value)
                    ) {
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: errorMsg(errorCode.FE48),
                      });
                    } else
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: error.pattern ? "" : errorMsg(errorCode.FE03),
                      });
                  }}
                  placeholder="Eg. example@email.com"
                  errorText={errors.email}
                  type="email"
                  suffix={
                    values.email !== "" && isEmailVerified ? (
                      <i className="edel-icon-tick" />
                    ) : (
                      <></>
                    )
                  }
                />
              </div>
              {showMobileMailBtn && !isEmailVerified && (
                <div className="emlVrfy">
                  <Verify
                    btnName="Verify"
                    disabled={
                      !(
                        values?.email !== null &&
                        values !== undefined &&
                        values?.email !== ""
                      ) ||
                      (errors?.email !== undefined &&
                        errors?.email !== null &&
                        errors?.email !== "" &&
                        errors?.email?.length > 0)
                    }
                    onClick={() => {
                      // gtmService({
                      //   action: "LEAD_PAGE",
                      //   label: "MOB_VERIFY",
                      // });

                      sendEmailOtp();
                    }}
                  />
                </div>
              )}
            </div>
            {showEmailOtp && !showMobileMailBtn ? (
              <div className="otpSection">
                <RegOtp
                  label="Enter Email OTP"
                  otpTimer={15}
                  eleId="eml_"
                  onChange={(val) => validateOtp("email", val)}
                  resendClicked={sendEmailOtp}
                  disableOtp={disableEmailOtp}
                  invalidOtp={invalidEmailOtp}
                />
              </div>
            ) : (
              ""
            )}
          </>
        )}
        {showMobile && (
          <>
            <div className="email">
              <div className="row emlInput">
                <label className="inptLbl">Mobile No.</label>
                <InputField
                  pattern={phoneNo}
                  disabled={true}
                  defaultValue={values?.mobile}
                  onChange={(value) => {
                    setShowMobileBtn(true);
                    setIsButtonDisabled(false);
                    setIsMobileVerified(false);
                    // setAllreadyExistMobOrEmail({ email: false, mob: false });
                    //  onChange("mobile", value);
                  }}
                  onBlur={(error) =>
                    setErrors({
                      ...errors,
                      // mobile: error.pattern ? '' : 'Please enter valid phone number',
                      mobile: error.pattern ? "" : errorMsg(errorCode.FE04),
                    })
                  }
                  placeholder="Eg. 9876543210"
                  errorText={errors.mobile}
                  type="tel"
                  inputPattern={integerExp}
                  suffix={
                    GlobalStore.user.mobile === values.mobile &&
                      values.mobile !== "" &&
                      isMobileVerified ? (
                      <i className="edel-icon-tick" />
                    ) : (
                      <></>
                    )
                  }
                  maxLength={10}
                  onKeyPress={(
                    keyEvent: React.KeyboardEvent<HTMLInputElement>
                  ) => {
                    if (keyEvent.key >= "0" && keyEvent.key <= "9") {
                      return true;
                    } else {
                      if (
                        keyEvent.key !== "Backspace" &&
                        keyEvent.key !== "Enter"
                      )
                        keyEvent.preventDefault();
                    }
                  }}
                />
              </div>
              {showMobileBtn && !isMobileVerified && (
                <div className="emlVrfy">
                  <Verify
                    btnName="Verify"
                    disabled={
                      Object.values([errors.mobile]).some((error) => error) ||
                      Object.values([values.mobile]).some((value) => !value)
                    }
                    onClick={() => {
                      // gtmService({ action: "LEAD_PAGE", label: "MOB_VERIFY" });

                      sendOtp();
                    }}
                  />
                </div>
              )}
            </div>
            {showMobileOtp && !showMobileBtn && (
              <div className="otpSection">
                <RegOtp
                  label="Enter Mobile OTP"
                  otpTimer={15}
                  eleId="mob_"
                  onChange={(val) => validateOtp("mobile", val)}
                  resendClicked={() => {
                    // gtmService({ action: "LEAD_PAGE", label: "OTP_RESEND" });
                    sendOtp();
                  }}
                  disableOtp={disableOtp}
                  invalidOtp={invalidOtp}
                />
              </div>
            )}
          </>
        )}
      </>
    );
  };
  return (
    <>
      {isPendingApproval &&
        pendingApprovalList.length > 0 &&
        pendingApprovalList.some((data: any) => data.status === "PENDING") && (
          <div className="approvalInfo">
            <div className="heading">Verification in progress</div>
            <div className="heading info">{`It will take upto 30 mins on working days (between 9 AM to 6 PM). You can wait or we will update you when verified, by Email/Whatsapp.`}</div>
          </div>
        )}
      <div className={"eSignForm " + (isLoading ? " op05" : "")}>
        <div className="clientStepsInfo">
          <div className="div-contents">
            <span className="tick-background">
              <i className="edel-icon-tick" />
            </span>
            <label className="text-content">
              <>
                Great, you have completed all the steps. Download the form and
                authenticate your application by entering a OTP
              </>
            </label>
          </div>
          <div className="button-section">
            <TransparentButton
              btnName="Download Form"
              onClick={() => {
                downloadForm(
                  `Esign_${GlobalStore.applicationID}`,
                  (resp: any) => {
                    setIsLoading(resp);
                  },
                  () => { },
                  false,
                  true,
                  GlobalStore?.stageStatus?.accountcategory
                );
              }}
            />
          </div>
        </div>
        {!proceedToAutheticate && (
          <DocStatus
            isPendingUpload={isPendingUpload}
            isPendingApproval={isPendingApproval}
            pendingUploadList={pendingUploadList}
            pendingApprovalList={pendingApprovalList}
            showResult={showResult}
          />
        )}
        {proceedToAutheticate && (
          <>
            <div className="dematFormRadioSelection">
              <Radio
                checked={radioSelection}
                className=""
                onChange={() => {
                  setRadioSelection(true);
                  setIsVerified((isVerified) => {
                    isVerified.type = "MOB";
                    return isVerified;
                  });
                }}
                name="radioSelection"
                label="Mobile Number"
              //disabled={true}
              />
              <Radio
                className="mgl10"
                checked={!radioSelection}
                onChange={() => {
                  setRadioSelection(false);
                  setIsVerified((isVerified) => {
                    isVerified.type = "EMAIL";
                    return isVerified;
                  });
                }}
                name="radioSelection"
                label="Email ID"
              //disabled={true}
              />
            </div>
            <>{generateEsignFields(isVerified.type == "MOB" ? true : false)}</>
          </>
        )}

        {/* <Backdrop isShow={seedingPopup} isCloseIcon={false}> */}
        {/* <div className="isSeeding"> */}
        {/* {DeviceContext().isMobile && <EdelLogoCenter />} */}
        {/* <img className="seedingIcon" src={isSeeding} alt="isSeeding" />
            <label className="seedingLabel">PAN Aadhar Link</label>
            <label className="subLAbel">
              Please link your PAN and Aadhar to continue with the account
              opening journey.
            </label>
            <div className="seedingCTA">
              <div className="borderBlue">
                <TransparentButton
                  isLoading={isLoading}
                  btnName="Re-Check"
                  onClick={() => reCheck()}
                />
              </div>
              <div>
                <Button btnName="Link PAN & Aadhar" onClick={navToLink} />
              </div>
            </div>
          </div>
        </Backdrop> */}
        {/* Error Msg Start*/}
        {errCode && (
          <div className="errMsgBlck">
            <ErrMsg>
              {typeof errCode === "number" ? (
                <>
                  <label>We are facing some technical issue.</label>
                  <label>
                    Please try after sometime (error code:{errCode})
                  </label>
                </>
              ) : (
                <label>{errCode}</label>
              )}
            </ErrMsg>
          </div>
        )}
        {/* Error Msg End*/}
        {!isPendingUpload && showResult && (
          <>
            {/* <label className='eSignInfo'>
                            You will receive an OTP on your Aadhar linked mobile number. You can E-sign directly.
                        </label> */}
            {!isPendingApproval && (
              <div className="readyToEsign">
                <img className="tickImg" src={blueTick} alt="ok" />
                <label className="readyInfo">
                  Great! Your documents are ready to be E-Signed. Proceed to
                  E-Sign by clicking the button below.
                </label>
              </div>
            )}
            <div className="eSignBtn">
              {!proceedToAutheticate && (
                <Button
                  btnName="Proceed To Authenticate"
                  isLoading={isLoading}
                  disabled={isPendingUpload}
                  onClick={(e: any) => {
                    setProceedToAutheticate(true);
                  }}
                />
              )}
              {proceedToAutheticate && (
                <Button
                  btnName="Submit"
                  isLoading={isLoading}
                  disabled={isPendingUpload || checkDisabledForm()}
                  onClick={(e: any) => {
                    updateStageStatus();
                    //setProceedToAutheticate(true);
                  }}
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default KRAAuthenticateForm;
